import { ROLE_TEMPLATES } from '@optiflow/types';

/** A role key as a person reads it: the template's name in the interface language, or the key itself for a role no template defines. */
export function roleLabel(key: string, language: string): string {
  const template = ROLE_TEMPLATES.find((candidate) => candidate.key === key);
  if (!template) return key;
  return language.startsWith('ar') ? template.nameAr : template.name;
}
